import ReactDOM from 'react-dom';

import modalStyles from './Modals.module.css';
import styles from './LeaveQAReviewModalV2.module.css';

const LeaveQAReviewModalV2 = ({ onStay, onLeave, episodeIds, reviewedIds, isExpertQa }) => {
    const totalCount = episodeIds.length;
    const doneCount = reviewedIds.length;
    const remainingCount = totalCount - doneCount;
    const pct = totalCount > 0 ? Math.round((doneCount / totalCount) * 100) : 0;

    const modal = (
        <div className={modalStyles.overlay}>
            <div className={`${modalStyles.shell} ${styles.shell}`}>

                <div className={styles.header}>
                    <div className={styles.headerIcon}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <rect x="2.5" y="2.5" width="12" height="12" rx="2.5" stroke="#7ab3f0" strokeWidth="1.3"/>
                            <path d="M5.5 6.5h6M5.5 8.5h6M5.5 10.5h3.5" stroke="#7ab3f0" strokeWidth="1.3" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <div className={styles.headerText}>
                        <div className={styles.title}>Save your progress and leave?</div>
                        <div className={styles.subtitle}>You still have episodes to review. Would you like to save your answers and come back later?</div>
                    </div>
                </div>

                <div className={styles.body}>

                    <div className={styles.progressSection}>
                        <div className={styles.progressHeader}>
                            <span className={styles.progressLabel}>Upload progress</span>
                            <span className={styles.progressCount}>
                                <span className={styles.progressCountAccent}>{doneCount}</span>
                                {' of '}
                                <span className={styles.progressCountAccent}>{totalCount}</span>
                                {' episodes reviewed'}
                            </span>
                        </div>
                        <div className={styles.progressTrack}>
                            <div className={styles.progressFill} style={{ width: `${pct}%` }} />
                        </div>
                        {isExpertQa ? (
                            <span className={styles.progressSub}>You have reviewed {doneCount} episode{doneCount === 1 ? '' : 's'}</span>
                        ) : (
                            <span className={styles.progressSub}>{remainingCount} episode{remainingCount === 1 ? '' : 's'} still need your review</span>
                        )}
                    </div>

                    <div className={styles.savedBox}>
                        <div className={styles.savedIcon}>
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path d="M2 3.5A1.5 1.5 0 0 1 3.5 2h7L13 5v7.5A1.5 1.5 0 0 1 11.5 14h-8A1.5 1.5 0 0 1 2 12.5V3.5z" stroke="#60c87a" strokeWidth="1.2"/>
                                <path d="M9.5 2v3.5H5V2" stroke="#60c87a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M4.5 9l2 2 4-3.5" stroke="#60c87a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className={styles.savedText}>
                            <div className={styles.savedTitle}>Your answers will be saved locally.</div>
                            <div className={styles.savedDesc}>When you return in this session, you can resume exactly where you left off. No need to start over.</div>
                        </div>
                    </div>

                    <div className={styles.actions}>
                        <button type="button" className={`${modalStyles.mbtn} ${modalStyles.mbtnCta}`} onClick={onLeave}>
                            <svg width="12" height="12" viewBox="0 0 15 15" fill="none">
                                <path d="M2 3.5A1.5 1.5 0 0 1 3.5 2h7L13 5v7.5A1.5 1.5 0 0 1 11.5 14h-8A1.5 1.5 0 0 1 2 12.5V3.5z" stroke="#1a1a1a" strokeWidth="1.3"/>
                                <path d="M9.5 2v3.5H5V2" stroke="#1a1a1a" strokeWidth="1.3" strokeLinecap="round"/>
                                <path d="M4.5 9l2 2 4-3.5" stroke="#1a1a1a" strokeWidth="1.3" strokeLinecap="round"/>
                            </svg>
                            Save &amp; leave
                        </button>
                        <button type="button" className={`${modalStyles.mbtn} ${modalStyles.mbtnGhost}`} onClick={onStay}>
                            Go back
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modal, document.body);
};

export default LeaveQAReviewModalV2;
